import * as React from 'react';
import { Handle, NodeProps, Node, Position } from '@xyflow/react';
import { DetailNode } from '../detail-node/detail-node.component';
import { floatingHandleStyles } from '../../styles/floating-handle-styles';

export const ActionNode = (props: NodeProps<Node<{ label: string }>>) => {
  const { data, isConnectable = true, id } = props;

  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        data-testid="action-node-handle"
        style={floatingHandleStyles.targetTop}
      />
      <DetailNode label={data.label} type="action" id={id} />
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
        data-testid="action-node-handle"
        style={floatingHandleStyles.sourceBottom}
      />
    </>
  );
};
